<template>
  <div class="chart-area">
    <highcharts class="hc" :options="chartOptions" ref="chart"></highcharts>
  </div>
</template>

<script>
  export default {
    props:{
      series: {
        type: Array
      }
    },
    watch:{
      series(){
        this.draw();
      }
    },
    computed: {
    },
    data(){
      return {
        chartOptions: {
          chart: {
            type: 'column',
            height: 220,
            style: {
              fontFamily: 'Roboto, sans-serif;'
            }
          },

          accessibility: {
            description : null
          },

          credits: {
            enabled: false
          },

          title: {
            text: null
          },

          subtitle: {
            text: null
          },

          xAxis: {
            tickColor: '#e2e2e2',
            lineColor: '#e2e2e2',
            type: 'category',
            labels: {
              rotation: -45,
              style: {
                fontSize: '9px'
              }
            },
            tickmarkPlacement: 'on',
            //max: 17,
            gridLineWidth: 1,
            minorTickInterval: 1

          },

          yAxis: {
            min: 0,
            title: {
              text: null
            },
            gridLineWidth: 1,
            minorTickInterval: 1000
          },
          legend: {
            enabled: false
          },

          tooltip: {
            pointFormat: "{point.y} 명<br/>",
            borderWidth: 0,
            borderRadius: 0,
            shadow: false
          },

          series: [{
            name: '출입자 수',
            data: [
            ],
            dataLabels: {
              enabled: true,
              rotation: -90,
              color: '#FFFFFF',
              align: 'right',
              format: '{point.y:.1f}', // one decimal
              y: 10, // 10 pixels down from the top
              style: {
                fontSize: '12px',
                'fontWeight': 'normal',
                'textOutline': ''
              }
            }
          }]
        },
      }
    },
    mounted(){
    },
    methods: {
      draw(){
        this.chartOptions.series[0].data = this.series;
      }
    }
  }
</script>

<style>

</style>
